import { render, staticRenderFns } from "./SO_report.vue?vue&type=template&id=2a16b1e6&"
import script from "./SO_report.vue?vue&type=script&lang=js&"
export * from "./SO_report.vue?vue&type=script&lang=js&"
import style0 from "./SO_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports